/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { randomGetRandomString } from "../../funcs/randomGetRandomString.js";
import { GetRandomStringRequest$zodSchema } from "../../models/getrandomstringop.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: GetRandomStringRequest$zodSchema.optional(),
};

export const tool$randomGetRandomString: ToolDefinition<typeof args> = {
  name: "random-get-random-string",
  description: `随机字符串

无论是需要生成一个安全的随机密码、一个唯一的Token，还是一个简单的随机ID，这个接口都能满足你。

## 功能概述
你可以精确地控制生成字符串的长度和字符集类型，非常灵活。

## 使用须知

> [!TIP]
> **字符集类型 \`type\` 详解**
> 你可以通过 \`type\` 参数精确控制生成的字符集：
> - **\`numeric\`**: 纯数字 (0-9)
> - **\`lower\`**: 纯小写字母 (a-z)
> - **\`upper\`**: 纯大写字母 (A-Z)
> - **\`alpha\`**: 大小写字母 (a-zA-Z)
> - **\`alphanumeric\`** (默认): 数字和大小写字母 (0-9a-zA-Z)
> - **\`hex\`**: 十六进制字符 (0-9a-f)`,
  scopes: ["read"],
  annotations: {
    "title": "",
    "destructiveHint": false,
    "idempotentHint": false,
    "openWorldHint": true,
    "readOnlyHint": true,
  },
  args,
  tool: async (client, args, ctx) => {
    const [result] = await randomGetRandomString(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    return formatResult(result.value);
  },
};
